export const DEFAULT_PUBLICATION_IMAGE =
    'https://firebasestorage.googleapis.com/v0/b/dev-as-cv.appspot.com/o/paper-publications.jpg?alt=media&token=b5742158-412c-4ab2-b5f9-3bd61302dde7';
